
import moment from 'moment'
import _ from 'lodash'
import 'moment-weekday-calc'

export default {
    name: 'calendar',
    methods: {
        noOfHolidays(holidays, from, to) {
            const days = _.countBy(holidays, function(o) {
                if(moment(o.date).isSameOrBefore(to, 'day') && moment(o.date).isSameOrAfter(from, 'day')) {
                    return true
                } else {
                    return false
                }
            })
            return days.true || 0;
        },
        noWorkingHours(workHours, holidays, from, to) {
            if(moment(to).isBefore(from, 'day')) {
                return 0;
            } else {
                const holidaysArray = _.map(holidays, 'date')
                const mondayHours = moment().isoWeekdayCalc(from,to,[1], holidaysArray) * Number(workHours.monday)
                const tuesdayHours = moment().isoWeekdayCalc(from,to,[2], holidaysArray) * Number(workHours.tuesday)
                const wednesdayHours = moment().isoWeekdayCalc(from,to,[3], holidaysArray) * Number(workHours.wednesday)
                const thursdayHours = moment().isoWeekdayCalc(from,to,[4], holidaysArray) * Number(workHours.thursday)
                const fridayHours = moment().isoWeekdayCalc(from,to,[5], holidaysArray) * Number(workHours.friday)
                const saturdayHours = moment().isoWeekdayCalc(from,to,[6], holidaysArray) * Number(workHours.saturday)
                const sundayHours = moment().isoWeekdayCalc(from,to,[7], holidaysArray) * Number(workHours.sunday)
    
                return mondayHours + tuesdayHours + wednesdayHours + thursdayHours + fridayHours + saturdayHours + sundayHours
            }
        },
        noWorkingDays(workHours, holidays, from, to) {
            if(moment(to).isBefore(from, 'day')) {
                return 0;
            } else {
                const holidaysArray = _.map(holidays, 'date')
                let mondayDays = 0, tuesdayDays = 0, wednesdayDays = 0, thursdayDays = 0, fridayDays = 0, saturdayDays = 0, sundayDays = 0;
                if(Number(workHours.monday) > 0) { mondayDays = moment().isoWeekdayCalc(from,to,[1], holidaysArray) }
                if(Number(workHours.tuesday) > 0) { tuesdayDays = moment().isoWeekdayCalc(from,to,[2], holidaysArray) }
                if(Number(workHours.wednesday) > 0) { wednesdayDays = moment().isoWeekdayCalc(from,to,[3], holidaysArray) }
                if(Number(workHours.thursday) > 0) { thursdayDays = moment().isoWeekdayCalc(from,to,[4], holidaysArray) }
                if(Number(workHours.friday) > 0) { fridayDays = moment().isoWeekdayCalc(from,to,[5], holidaysArray) }
                if(Number(workHours.saturday) > 0) { saturdayDays = moment().isoWeekdayCalc(from,to,[6], holidaysArray) }
                if(Number(workHours.sunday) > 0) { sundayDays = moment().isoWeekdayCalc(from,to,[7], holidaysArray) }

                return mondayDays + tuesdayDays + wednesdayDays + thursdayDays + fridayDays + saturdayDays + sundayDays
            }
        },
        availabilityCommitment(availabilityCommitment, startBalance, registrations, workHours, holidays, from, to) {
            if(availabilityCommitment) {
                const workWeekTime = workHours.workWeekTime;
                const ac = 20 * Number(workWeekTime)/37;
                let q1StartBalance = 0;
                let q2StartBalance = 0;
                let q3StartBalance = 0;
                let q4StartBalance = 0;
                
                let q1WorkingHours, q2WorkingHours, q3WorkingHours, q4WorkingHours = false;
                if(moment(from).quarter() === 1 && moment(from).isSameOrAfter(moment().startOf('year'), 'year')) {
                    let endDate = false
                    if(moment(to).isAfter(moment().quarter(1).endOf('quarter'))) {
                        endDate = moment().quarter(1).endOf('quarter')
                    } else {
                        endDate = to
                    }
                    q1WorkingHours = this.noWorkingHours(workHours, holidays, from,  endDate)
                    q2WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(2).startOf('quarter'),  moment().quarter(2).endOf('quarter'))
                    q3WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(3).startOf('quarter'),  moment().quarter(3).endOf('quarter'))
                    q4WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(4).startOf('quarter'),  moment().quarter(4).endOf('quarter'))
                    
                    if(startBalance !== 0) {
                        q1StartBalance = startBalance
                    }
                }
                else if(moment(from).quarter() === 2 && moment(from).isSameOrAfter(moment().startOf('year'), 'year')) {
                    let q2EndDate, q3EndDate = false
                    if(moment(to).isAfter(moment().quarter(2).endOf('quarter'))) {
                        q2EndDate = moment().quarter(2).endOf('quarter')
                        if(moment(to).isAfter(moment().quarter(3).endOf('quarter'))) {
                            q3EndDate = moment().quarter(3).endOf('quarter')
                        } else {
                            q3EndDate = to
                        }
                    } else {
                        q2EndDate = to
                    }
                    q1WorkingHours = 0;
                    q2WorkingHours = this.noWorkingHours(workHours, holidays, from,  q2EndDate)
                    q3WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(3).startOf('quarter'),  q3EndDate)
                    q4WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(4).startOf('quarter'),  to)
                    
                    if(startBalance !== 0) {
                        q2startBalance = startBalance
                    }
                }
                else if(moment(from).quarter() === 3 && moment(from).isSameOrAfter(moment().startOf('year'), 'year')) {
                    let q3EndDate = false
                    if(moment(to).isAfter(moment().quarter(3).endOf('quarter'))) {
                        q3EndDate = moment().quarter(3).endOf('quarter')
                    } else {
                        q3EndDate = to
                    }
                    q1WorkingHours = 0;
                    q2WorkingHours = 0;
                    q3WorkingHours = this.noWorkingHours(workHours, holidays, from,  q3EndDate)
                    q4WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(4).startOf('quarter'),  to)

                    if(startBalance !== 0) {
                        q3StartBalance = startBalance
                    }
                }
                else if(moment(from).quarter() === 4 && moment(from).isSameOrAfter(moment().startOf('year'), 'year')) {
                    q1WorkingHours = 0;
                    q2WorkingHours = 0;
                    q3WorkingHours = 0;
                    q4WorkingHours = this.noWorkingHours(workHours, holidays, from,  to)

                    if(startBalance !== 0) {
                        q4StartBalance = startBalance
                    }
                } else {
                    q1WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(1).startOf('quarter'),  moment().quarter(1).endOf('quarter'))
                    q2WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(2).startOf('quarter'),  moment().quarter(2).endOf('quarter'))
                    q3WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(3).startOf('quarter'),  moment().quarter(3).endOf('quarter'))
                    q4WorkingHours = this.noWorkingHours(workHours, holidays, moment().quarter(4).startOf('quarter'),  moment().quarter(4).endOf('quarter'))
                }

                const q1Hours = _.sumBy(_.filter(registrations, {'quarter': 1}), 'time')
                const q2Hours = _.sumBy(_.filter(registrations, {'quarter': 2}), 'time')
                const q3Hours = _.sumBy(_.filter(registrations, {'quarter': 3}), 'time')
                const q4Hours = _.sumBy(_.filter(registrations, {'quarter': 4}), 'time')

                if(moment().quarter() === 1) {
                    let q1sum = 0;
                    if(q1Hours + q1StartBalance - q1WorkingHours >= ac) {
                        q1sum = q1Hours + q1StartBalance - q1WorkingHours - ac;
                    } else {
                        q1sum = q1Hours + q1StartBalance - q1WorkingHours
                    }
                    return Math.round(q1sum * 100) / 100;
                }
                else if(moment().quarter() === 2) {
                    let q1sum, q2sum = 0;
                    if(q1Hours - q1WorkingHours >= ac) {
                        q1sum = q1Hours - q1WorkingHours - ac;
                    } else {
                        q1sum = q1Hours - q1WorkingHours
                    }
                    if(q2Hours + q2StartBalance - (q1sum + q2WorkingHours) >= ac) {
                        q2sum = q2Hours + q2StartBalance + q1sum - q2WorkingHours - ac;
                    } else {
                        q2sum = q2Hours + q2StartBalance + q1sum - q2WorkingHours
                    }
                    return Math.round(q2sum * 100) / 100;
                }
                else if(moment().quarter() === 3) {
                    let q1sum, q2sum, q3sum = 0;
                    if(q1Hours - q1WorkingHours >= ac) {
                        q1sum = q1Hours - q1WorkingHours - ac;
                    } else {
                        q1sum = q1Hours - q1WorkingHours
                    }
                    if(q2Hours - (q1sum + q2WorkingHours) >= ac) {
                        q2sum = q2Hours + q1sum - q2WorkingHours - ac;
                    } else {
                        q2sum = q2Hours + q1sum - q2WorkingHours
                    }
                    if(q3Hours + q3StartBalance - (q2sum + q3WorkingHours) >= ac) {
                        q3sum = q3Hours + q3StartBalance + q2sum - q3WorkingHours - ac;
                    } else {
                        q3sum = q3Hours + q3StartBalance + q2sum - q3WorkingHours
                    }
                    return Math.round(q3sum * 100) / 100;
                }
                else if(moment().quarter() === 4) {
                    let q1sum, q2sum, q3sum, q4sum = 0;
                    if(q1Hours - q1WorkingHours >= ac) {
                        q1sum = q1Hours - q1WorkingHours - ac;
                    } else {
                        q1sum = q1Hours - q1WorkingHours
                    }
                    if(q2Hours - (q1sum + q2WorkingHours) >= ac) {
                        q2sum = q2Hours + q1sum - q2WorkingHours - ac;
                    } else {
                        q2sum = q2Hours + q1sum - q2WorkingHours
                    }
                    if(q3Hours - (q2sum + q3WorkingHours) >= ac) {
                        q3sum = q3Hours + q2sum - q3WorkingHours - ac;
                    } else {
                        q3sum = q3Hours + q2sum - q3WorkingHours
                    }
                    if(q4Hours + q4StartBalance - (q3sum + q4WorkingHours) >= ac) {
                        q4sum = q4Hours + q4StartBalance + q3sum - q4WorkingHours - ac;
                    } else {
                        q4sum = q4Hours + q4StartBalance + q3sum - q4WorkingHours
                    }
                    return Math.round(q4sum * 100) / 100;
                }
            } else {
                return 0;
            }
        },
        vacationDays(from, to, isThereAStartDate){
            const monthsDiff = moment(to).diff(moment(from), 'month')
            if(from && to && isThereAStartDate) {
                if(monthsDiff === 0) {
                    const daysDiff = moment(to).diff(moment(from), 'days')
                    if(daysDiff >= 2.08) {
                        return 2.08
                    } else {
                        // if employed less than a month = 0.07 days of vacation per day  https://indberet.virk.dk/feriepengeinfo/indberetning-af-feriepenge/optjening-af-feriedage
                        return daysDiff * 0.07                   
                    }
                } else {
                    // every month of employment gives 2.08 days of vacation
                    return monthsDiff * 2.08
                }
            } else {
                return '-'
            }

        },
        noVacationDaysLeft(from, to, vacation, startBalance) {
            if(from && to && vacation && startBalance) {
                const value = this.vacationDays(from, to, true) - _.sumBy(vacation, 'time') + Number(startBalance);
                const roundedValue = Math.round(value * 100) / 100;
                return roundedValue
            } else {
                return '-'
            }
        },
        isDateAholiday(date, holidays) {
            return _.includes( _.flatMap(holidays, 'date'), moment(date).format('YYYY-MM-DD'))
        }
    }
}